/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCartCartAddproductPost } from '../fn/cart/api-cart-cart-addproduct-post';
import { ApiCartCartAddproductPost$Params } from '../fn/cart/api-cart-cart-addproduct-post';
import { apiCartCartAddproductPost$Plain } from '../fn/cart/api-cart-cart-addproduct-post-plain';
import { ApiCartCartAddproductPost$Plain$Params } from '../fn/cart/api-cart-cart-addproduct-post-plain';
import { apiCartCartAddproductsPost } from '../fn/cart/api-cart-cart-addproducts-post';
import { ApiCartCartAddproductsPost$Params } from '../fn/cart/api-cart-cart-addproducts-post';
import { apiCartCartAddproductsPost$Plain } from '../fn/cart/api-cart-cart-addproducts-post-plain';
import { ApiCartCartAddproductsPost$Plain$Params } from '../fn/cart/api-cart-cart-addproducts-post-plain';
import { apiCartCartCalculatevatPost } from '../fn/cart/api-cart-cart-calculatevat-post';
import { ApiCartCartCalculatevatPost$Params } from '../fn/cart/api-cart-cart-calculatevat-post';
import { apiCartCartCalculatevatPost$Plain } from '../fn/cart/api-cart-cart-calculatevat-post-plain';
import { ApiCartCartCalculatevatPost$Plain$Params } from '../fn/cart/api-cart-cart-calculatevat-post-plain';
import { apiCartCartLinesCartLineIdDelete } from '../fn/cart/api-cart-cart-lines-cart-line-id-delete';
import { ApiCartCartLinesCartLineIdDelete$Params } from '../fn/cart/api-cart-cart-lines-cart-line-id-delete';
import { apiCartCartLinesCartLineIdDelete$Plain } from '../fn/cart/api-cart-cart-lines-cart-line-id-delete-plain';
import { ApiCartCartLinesCartLineIdDelete$Plain$Params } from '../fn/cart/api-cart-cart-lines-cart-line-id-delete-plain';
import { apiCartCartUpdatequantityPut } from '../fn/cart/api-cart-cart-updatequantity-put';
import { ApiCartCartUpdatequantityPut$Params } from '../fn/cart/api-cart-cart-updatequantity-put';
import { apiCartCartUpdatequantityPut$Plain } from '../fn/cart/api-cart-cart-updatequantity-put-plain';
import { ApiCartCartUpdatequantityPut$Plain$Params } from '../fn/cart/api-cart-cart-updatequantity-put-plain';
import { apiCartCartValidateGet } from '../fn/cart/api-cart-cart-validate-get';
import { ApiCartCartValidateGet$Params } from '../fn/cart/api-cart-cart-validate-get';
import { apiCartCartValidateGet$Plain } from '../fn/cart/api-cart-cart-validate-get-plain';
import { ApiCartCartValidateGet$Plain$Params } from '../fn/cart/api-cart-cart-validate-get-plain';
import { apiCartGet } from '../fn/cart/api-cart-get';
import { ApiCartGet$Params } from '../fn/cart/api-cart-get';
import { apiCartGet$Plain } from '../fn/cart/api-cart-get-plain';
import { ApiCartGet$Plain$Params } from '../fn/cart/api-cart-get-plain';
import { Cart } from '../models/cart';
import { Response } from '../models/response';

@Injectable({ providedIn: 'root' })
export class CartService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCartGet()` */
  static readonly ApiCartGetPath = '/api/cart';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartGet$Plain$Response(params?: ApiCartGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Cart>> {
    return apiCartGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartGet$Plain(params?: ApiCartGet$Plain$Params, context?: HttpContext): Observable<Cart> {
    return this.apiCartGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Cart>): Cart => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartGet$Response(params?: ApiCartGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Cart>> {
    return apiCartGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartGet(params?: ApiCartGet$Params, context?: HttpContext): Observable<Cart> {
    return this.apiCartGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Cart>): Cart => r.body)
    );
  }

  /** Path part for operation `apiCartCartUpdatequantityPut()` */
  static readonly ApiCartCartUpdatequantityPutPath = '/api/cart/cart/updatequantity';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartUpdatequantityPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartUpdatequantityPut$Plain$Response(params?: ApiCartCartUpdatequantityPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartUpdatequantityPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartUpdatequantityPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartUpdatequantityPut$Plain(params?: ApiCartCartUpdatequantityPut$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartUpdatequantityPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartUpdatequantityPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartUpdatequantityPut$Response(params?: ApiCartCartUpdatequantityPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartUpdatequantityPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartUpdatequantityPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartUpdatequantityPut(params?: ApiCartCartUpdatequantityPut$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartUpdatequantityPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiCartCartAddproductPost()` */
  static readonly ApiCartCartAddproductPostPath = '/api/cart/cart/addproduct';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartAddproductPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartAddproductPost$Plain$Response(params?: ApiCartCartAddproductPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartAddproductPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartAddproductPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartAddproductPost$Plain(params?: ApiCartCartAddproductPost$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartAddproductPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartAddproductPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartAddproductPost$Response(params?: ApiCartCartAddproductPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartAddproductPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartAddproductPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartAddproductPost(params?: ApiCartCartAddproductPost$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartAddproductPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiCartCartAddproductsPost()` */
  static readonly ApiCartCartAddproductsPostPath = '/api/cart/cart/addproducts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartAddproductsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartAddproductsPost$Plain$Response(params?: ApiCartCartAddproductsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartAddproductsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartAddproductsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartAddproductsPost$Plain(params?: ApiCartCartAddproductsPost$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartAddproductsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartAddproductsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartAddproductsPost$Response(params?: ApiCartCartAddproductsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartAddproductsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartAddproductsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartAddproductsPost(params?: ApiCartCartAddproductsPost$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartAddproductsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiCartCartLinesCartLineIdDelete()` */
  static readonly ApiCartCartLinesCartLineIdDeletePath = '/api/cart/cart/lines/{cartLineId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartLinesCartLineIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartCartLinesCartLineIdDelete$Plain$Response(params: ApiCartCartLinesCartLineIdDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartLinesCartLineIdDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartLinesCartLineIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartCartLinesCartLineIdDelete$Plain(params: ApiCartCartLinesCartLineIdDelete$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartLinesCartLineIdDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartLinesCartLineIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartCartLinesCartLineIdDelete$Response(params: ApiCartCartLinesCartLineIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartLinesCartLineIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartLinesCartLineIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartCartLinesCartLineIdDelete(params: ApiCartCartLinesCartLineIdDelete$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartLinesCartLineIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiCartCartValidateGet()` */
  static readonly ApiCartCartValidateGetPath = '/api/cart/cart/validate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartValidateGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartCartValidateGet$Plain$Response(params?: ApiCartCartValidateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartValidateGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartValidateGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartCartValidateGet$Plain(params?: ApiCartCartValidateGet$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartValidateGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartValidateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartCartValidateGet$Response(params?: ApiCartCartValidateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartValidateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartValidateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCartCartValidateGet(params?: ApiCartCartValidateGet$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartValidateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiCartCartCalculatevatPost()` */
  static readonly ApiCartCartCalculatevatPostPath = '/api/cart/cart/calculatevat';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartCalculatevatPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartCalculatevatPost$Plain$Response(params?: ApiCartCartCalculatevatPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartCalculatevatPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartCalculatevatPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartCalculatevatPost$Plain(params?: ApiCartCartCalculatevatPost$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartCalculatevatPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCartCartCalculatevatPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartCalculatevatPost$Response(params?: ApiCartCartCalculatevatPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCartCartCalculatevatPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCartCartCalculatevatPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCartCartCalculatevatPost(params?: ApiCartCartCalculatevatPost$Params, context?: HttpContext): Observable<Response> {
    return this.apiCartCartCalculatevatPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

}
